(function () {
  function initCard(card) {
    if (card.__zwcSwatchInit) return;
    card.__zwcSwatchInit = true;

    var dots = card.querySelectorAll('[data-zwc-swatch]');
    if (!dots.length) return;

    var img = card.querySelector('[data-zwc-card-img]');

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        // Don't follow the card link when a dot is tapped
        e.preventDefault();
        e.stopPropagation();

        // Mark selected
        dots.forEach(function (d) { d.classList.remove('is-selected'); });
        dot.classList.add('is-selected');

        // Store chosen variant on the card root (quick-buy reads this)
        var vid = dot.getAttribute('data-variant-id');
        if (vid) card.setAttribute('data-selected-variant', vid);

        // Swap image if this variant has one
        if (img) {
          var newSrc = dot.getAttribute('data-variant-image');
          var newSet = dot.getAttribute('data-variant-srcset');
          if (newSrc) {
            img.setAttribute('src', newSrc);
            if (newSet) img.setAttribute('srcset', newSet);
          } else {
            // No variant image — restore the product's default
            img.setAttribute('src', img.getAttribute('data-default-src') || img.src);
            var defSet = img.getAttribute('data-default-srcset');
            if (defSet) img.setAttribute('srcset', defSet);
          }
        }

        // Broadcast selection so QuickView (or anything listening) can react
        card.dispatchEvent(new CustomEvent('zwc:variant-selected', {
          bubbles: true,
          detail: {
            variantId: vid,
            color: dot.getAttribute('title') || '',
            productHandle: card.getAttribute('data-product-handle')
          }
        }));
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-zwc-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init after occasion/filter re-render
  document.addEventListener('zwc:rerender', function () { initAll(document); });
})();